'use client';

import * as React from 'react';
import { CallUsMenu } from '@/components/Menus/CallUsMenu';
import { PlainButton } from '@/components/PlainButton';
import { useSiteLinkPrefix } from '@/hooks/useSiteLinkPrefix';
import { CmsSiteConfig } from '@/services/cms/models/CmsSiteConfig';

export interface ContactUsProps {
    divider?: React.ReactNode;
    siteConfig: CmsSiteConfig;
}

export const ContactUs = ({ divider, siteConfig }: ContactUsProps) => {
    const addSiteLinkPrefix = useSiteLinkPrefix();

    const { contactUsLink, phoneNumbers, primaryPhoneNumber } = siteConfig.siteConfig;
    if (contactUsLink) {
        return (
            <PlainButton href={addSiteLinkPrefix(contactUsLink.url)} target={contactUsLink.openInNew ? '_blank' : undefined}>
                {contactUsLink.title}
            </PlainButton>
        );
    }

    return (
        <>
            {primaryPhoneNumber || phoneNumbers ? (
                <>
                    <CallUsMenu primaryPhoneNumber={primaryPhoneNumber} phoneNumbers={phoneNumbers} />
                    {divider}
                </>
            ) : null}
            <PlainButton href="mailto:res@jucyworld.com">Email Us</PlainButton>
        </>
    );
};
